<template>
    <ul v-if="items">
        <template v-for="(item, i) of items">
            <li
                v-if="visible(item) && !item.separator"
                :key="item.label || i"
                :class="[
                    {
                        'layout-menuitem-category': root,
                        'active-menuitem': activeIndex === i && !item.to && !item.disabled
                    }
                ]"
            >
                <template v-if="root">
                    <div v-if="item.label" class="layout-menuitem-root-text white-space-nowrap overflow-hidden text-overflow-ellipsis" :aria-label="item.label">
                        {{ $t(`${item.label}`) }}
                    </div>
                    <appsubmenu :items="visible(item) && item.items" @menuitem-click="$emit('menuitem-click', $event)" />
                </template>
                <template v-else>
                    <router-link
                        v-if="item.to"
                        v-ripple
                        :to="item.to"
                        :class="[item.class, 'p-ripple', { 'p-disabled': item.disabled }]"
                        :style="item.style"
                        :target="item.target"
                        :aria-label="item.label"
                        active-class="router-link-active"
                        exact-active-class="router-link-exact-active"
                        role="menuitem"
                        @click="onMenuItemClick($event, item, i)"
                    >
                        <i v-badge.danger v-if="item.resource == 'doctor-chat' && store.getChatCount == true" :class="item.icon" class="badge-center" />
                        <i v-else :class="item.icon" />
                        <span class="white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ $t(`${item.label}`) }}</span>
                        <span v-if="isBookingPendingItem(item)" class="booking-pending-pill">{{ pendingBookingCount }} Pending</span>
                        <i v-if="item.items" :class="activeIndex === i ? 'ri-arrow-up-s-line ri-lg menuitem-toggle-icon' : 'ri-arrow-down-s-line ri-lg menuitem-toggle-icon'" />
                    </router-link>

                    <a
                        v-if="!item.to"
                        v-ripple
                        :href="item.url || '#'"
                        :style="item.style"
                        :class="[item.class, 'p-ripple', { 'p-disabled': item.disabled }]"
                        :target="item.target"
                        :aria-label="item.label"
                        role="menuitem"
                        @click="onMenuItemClick($event, item, i)"
                    >
                        <i :class="item.icon" />

                        <span class="white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ $t(`${item.label}`) }}</span>
                        <span v-if="isBookingPendingItem(item)" class="booking-pending-pill">{{ pendingBookingCount }} Pending</span>
                        <i v-if="item.items" :class="activeIndex === i ? 'ri-arrow-up-s-line ri-lg menuitem-toggle-icon' : 'ri-arrow-down-s-line ri-lg menuitem-toggle-icon'" />
                    </a>

                    <transition name="layout-submenu-wrapper">
                        <appsubmenu v-show="activeIndex === i" :items="visible(item) && item.items" @menuitem-click="$emit('menuitem-click', $event)" />
                    </transition>
                </template>
            </li>
            <li v-if="visible(item) && item.separator" :key="'separator' + i"><hr class="p-menu-separator" :style="item.style" /></li>
        </template>
    </ul>
</template>
<script>
import ability from '@/libs/acl/ability'
import { canAccessAmplitudeDashboard } from '@/libs/acl/amplitudeAccess'
// import { db } from '@/libs/firebase'
import { useChatCountStore } from '@/store/chatCountStore'
import { service as mcuBookingService } from '@/modules/mcu_booking/service'

export default {
    name: 'Appsubmenu',
    props: {
        // eslint-disable-next-line vue/require-default-prop
        items: Array,
        root: {
            type: Boolean,
            default: false
        }
    },
    emits: ['menuitem-click'],
    data() {
        return {
            activeIndex: null,
            user: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : 'undefined',
            // currentPath: this.$route.path

            chatCount: 0,
            store: useChatCountStore(),
            pendingBookingCount: 0
        }
    },
    mounted() {
        this.expandMenuForCurrentRoute()
        if (this.hasBookingMenuItem()) {
            if (ability.can('view', 'bookings')) {
                this.fetchPendingBookingCount()

                window.Echo.channel('bookings').listen('.booking.updated', this.onBookingUpdated)
            }
        }
    },
    watch: {
        '$route.path'() {
            this.expandMenuForCurrentRoute()
        }
    },

    beforeUnmount() {
        // the Pusher connection outlives this component (one per tab)
        window.Echo?.channel('bookings').stopListening('.booking.updated', this.onBookingUpdated)
    },

    methods: {
        onBookingUpdated() {
            this.fetchPendingBookingCount()
        },
        // showChatCount: function () {
        //     db.collection('chat_queues')
        //         .where('status', '==', 'pending')
        //         .onSnapshot(
        //             (onSnapshot) => {
        //                 if (onSnapshot.size > 0) {
        //                     this.supportChatToast({
        //                         severity: 'info',
        //                         summary: 'Go to Chat',
        //                         detail: 'You have ' + onSnapshot.size + ' chat notification !'
        //                     })
        //                     this.newSupportChat(this.user.id)
        //                     this.chatCount = onSnapshot.size
        //                 } else {
        //                     this.chatCount = 0
        //                 }
        //             },
        //             (err) => {
        //                 console.log(`Encountered error: ${err}`)
        //                 this.chatCount = 0
        //             }
        //         )
        // },
        onMenuItemClick(event, item, index) {
            if (item.disabled) {
                event.preventDefault()
                return
            }

            if (!item.to && !item.url) {
                event.preventDefault()
            }

            //execute command
            if (item.command) {
                item.command({ originalEvent: event, item: item })
            }

            this.activeIndex = index === this.activeIndex ? null : index

            this.$emit('menuitem-click', {
                originalEvent: event,
                item: item
            })
        },
        async fetchPendingBookingCount() {
            const response = await mcuBookingService.getPendingCount({
                user_facility: 1
            })

            this.pendingBookingCount = response?.data || 0
        },
        hasBookingMenuItem() {
            return Array.isArray(this.items) && this.items.some((item) => item?.to === '/mcu-booking')
        },
        getBadgeValue(item) {
            if (item?.to === '/mcu-booking') {
                return this.pendingBookingCount > 0 ? this.pendingBookingCount : null
            }
            return item?.badge
        },
        isBookingPendingItem(item) {
            return item?.to === '/mcu-booking' && this.pendingBookingCount > 0
        },
        expandMenuForCurrentRoute() {
            if (!Array.isArray(this.items) || this.root) {
                return
            }

            const path = this.$route.path
            this.items.forEach((item, index) => {
                if (item.to === path) {
                    return
                }
                if (Array.isArray(item.items) && item.items.some((child) => child.to === path)) {
                    this.activeIndex = index
                }
            })
        },
        visible(item) {
            if (item.resource == 'doctor-chat') {
                if (this.user !== 'undefined' && this.user.role == 'doctor' && !this.user.doctor.support_chat_enable) {
                    return false
                }
            }

            // for defined resource and action in menu
            if (item.resource) {
                if (item.resource === 'amplitude_dashboard' && canAccessAmplitudeDashboard(item.action || 'view')) {
                    return true
                }
                if (ability.can(item.action || 'index', item.resource)) {
                    return true
                }

                if (item.items && item.items.length) {
                    return item.items.some((child) => this.visible(child))
                }
                return false
            }

            if (item.items && item.items.length && item.items[0].resource == 'doctor-chat' && this.user.role != 'doctor') {
                return false
            }

            // for not defined resource in menu
            if (item.items && item.items.length) {
                return item.items.some((child) => this.visible(child))
            }

            return true
        }
        // childRouteExist(items) {
        //   let isExist = false
        //   if (items) {
        //     for (let i = 0, length = items.length; i < length; i++) {
        //       if (items[i].to == this.currentPath) {
        //         isExist = true
        //         break
        //       }
        //     }
        //   }
        //   return isExist
        // }
    }
}
</script>

<style scoped>
.booking-pending-pill {
    margin-left: auto;
    padding: 0.35rem 0.75rem;
    border-radius: 9999px;
    background: #f9e4a4;
    color: #92400e;
    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
}
</style>
